
import { getClient, authHeader } from './session'
import { getUrl } from './connection'
import { alert } from './stores/alert'

import { loading } from './stores/loading'
import { translate } from './i18n'
import { libTranslate } from './libraryDictionary'

let models = null;

const getModels = async () => {
	const clientId = getClient();
	if (!clientId) {
		return null;
	}

	if (!models) {
		const [url, method] = await getUrl('dbmodels',{ clientId });
	
		loading.newLoading();
		try {
			const response = await fetch(url, {
				method,
				headers: {
					'Content-Type': 'application/json; charset=utf-8',
					...authHeader()
				}
			});
			if (response.status === 200) {
				const modelsResponse = await response.json();
                // Usamos un objeto para evitar duplicados recorriendo el array una vez, en lugar
                // de tener que hacer una búsqueda de orden cuadrático
                const includedIds = {};
				models = modelsResponse.models.map(({ line, model, description, article, article2, width, height, depth, restrictions, have3D, thumbnail }) => ({
					line, model, 
					name: libTranslate(article,description),
					article, article2, width, height, depth, restrictions,
                    have3D, thumbnail
				})).filter(item => {
                    // Si ya hemos incluido un artículo, no lo volvemos a incluir
                    if (includedIds[item.article]) {
                        return false;
                    }
                    includedIds[item.article] = true;
                    return true;
                });
			}
			else {
				alert.newAlert({ message: translate('alerts_errors_loadDBModels'), type: 'error' });
			}
		}
		catch (error) {
			alert.newAlert({ message: translate('alerts_errors_loadDBModels'), type: 'error'});
		}
		finally {
			loading.removeLoading();
		}
	}

    return models;
}

const getArticleParts = async (article) => {
    const [url, method] = await getUrl('dbmodelParts');

    let result = [];

    loading.newLoading()
    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify([article])
        })
        if (response.status !== 200) {
            alert.newAlert({ message: translate('alerts_error_loadModelPartData'), type: 'error' })
        }
        else {
            const partsResponse = await response.json();
            const articleParts = partsResponse.models[article];
            if (articleParts) {
                const removeComplete = Object.keys(articleParts).length > 1;
                for (const key in articleParts) {
                    if (!(removeComplete && key.toUpperCase() === "COM")) {
                        // Quitamos la parte Completo, porque se implementará
                        // aplicando la de una parte en todas las demás, pero
                        // solamente si hay más de una parte, porque puede que
                        // solamente exista la parte COM
                        result.push({
                            part: key,
                            partName: libTranslate(`PART_NAME_${key}`, articleParts[key]),
                            fabric: "",
                            description: "",
                            serie: "",
                            type: ""
                        });
                    }
                }
            }
        }

    }
    catch (error) {
        alert.newAlert({ message: translate('alerts_error_loadModelPartData'), type: 'error' });
    }
    finally {
        loading.removeLoading();
    }

    return result;
}

const accessories = {};

const getAccessories = async (article) => {
    const [url, method] = await getUrl('dbmodelAccessories',{ id: article });

    accessories[article] = accessories[article] || [];
    if (accessories[article].length === 0) {
        loading.newLoading();
        try {
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            });
            if (response.status === 200) {
                const data = await response.json();
                accessories[article] = data.accessories.map((accData) => {
                    const {
                        finish,
                        id,
                        id3d,
                        name,
                        required,
                        type,
                        typeName
                    } = accData;
                    const isDefault = accData.default;
                    return {
                        default: isDefault,
                        finish,
                        id,
                        id3d,
                        name: libTranslate(id, name),
                        required,
                        type,
                        typeName: libTranslate(`VARIANT_TYPE_${type}`, typeName)
                    }
                });
            }
            else {
                return [];
            }
        }
        catch (e) {
            alert.newAlert({ message: translate('alerts_error_notLoadAccessories'), type: 'error' });
        }
        finally {
            loading.removeLoading();
        }   
    }
    return accessories[article];
}

const getAccessoryTypes = async (article) => {
    const accessories = await getAccessories(article);
    const types = [];
    accessories.forEach(accData => {
        if (!types.find(({type}) => type === accData.type)) {
            // Primero añadimos el tipo de accesorio
            types.push({
                type: accData.type,
                typeName: accData.typeName,
                accessory: "",
                accessoryName: "",
                units: 1,
                required: accData.required
            })
        }

        // Después, si hay un accesorio por defecto, rellenamos también los datos
        if (accData.default) {
            types.some(item => {
                if (item.type === accData.type) {
                    item.accessory = accData.id;
                    item.accessoryName = accData.name;
                    return true;
                }
            })
        }
    })
    return types;
}

const getModelData = async (modelId) => {
    const [url, method] = await getUrl('dbmodelData',{ modelId });

    const response = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    });
    return await response.json();
}

export { getModels, getArticleParts, getAccessoryTypes, getAccessories, getModelData }